export function setReceivedPhoneNumber(state, payload) {
  state.receivedPhoneNumber = payload;
}

export function clearReceivedPhoneNumber(state) {
  state.receivedPhoneNumber = '';
}

export function setSendDate(state, payload) {
  state.sendDate = payload;
}

export function clearSendDate(state) {
  state.sendDate = '';
}

export function setHasSuccessfullyCreatedAccount(state, payload) {
  state.hasSuccessfullyCreatedAccount = payload;
}

export function setCustomerNumber(state, payload) {
  state.customerNumber = payload;
}

export function clearCustomerNumber(state) {
  state.customerNumber = undefined;
}
